import { StatusBar, Style } from '@capacitor/status-bar'

export const setStatusBarStyleDark = async () => {
  await StatusBar.setStyle({ style: Style.Dark }).catch(e => {
    //TODO catch error not support platform
  })
}

export const setStatusBarStyleLight = async () => {
  await StatusBar.setStyle({ style: Style.Light }).catch(e => {
    //TODO catch error not support platform
  })
}

export const setStatusBarStyle = (isDark: boolean) => {
  return isDark ? setStatusBarStyleDark() : setStatusBarStyleLight()
}
